<template>
    <div class="container-fluid" style="margin-left:-28px;">
        <div class="col-xs-12">
            <p class="title">美团门票验证电话</p>
            <p class="telephone">400-660-1065</p>
            <p class="telephone-tips">1，按 "3" 进入验证功能</p>
            <p class="telephone-tips">2，再按 "2" 进入旅游门票验证</p>
        </div>
        <div class="col-xs-12 table-tips">
            <span class="table-title">绑定商家电话设置</span>
            <span>(只有已绑定的电话才有权限验证)</span>
            <div class="other-thead">
                <span class="tip-status" style="margin-left: 5px;"></span>
                <span>绑定的电话可以是固话或手机号，固话请加区号，录入纯数字不加’-‘</span>
            </div>
            <table class="table table-bordered table-hover bound-table">
                <thead>
                    <tr>
                        <td>绑定电话</td>
                        <td>操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in phones">
                        <td>{{item.phone}}</td>
                        <td>
                            <button class="btn btn-primary" v-on:click="unbindPhone(item)">撤销绑定</button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="number" v-model="phoneNumber" style="width:250px;margin: 0 auto">
                        </td>
                        <td>
                            <button class="btn btn-primary" v-on:click="bindPhone()">进行绑定</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style lang="postcss">
.container-fluid {
    .col-xs-12 {
        p {
            margin: 0 0 10px 0;
        }
        .title {
            margin-top: 40px;
            font-size: 20px;
            font-weight: 700;
        }
        .telephone {
            font-size: 22px;
            color: #FF9D3C;
        }
        .telephone-tips {
            font-size: 16px;
            color: #FF9D3C;
        }
    }
    .table-tips {
        margin-top: 40px;
        .table-title {
            font-size: 20px;
            font-weight: 700;
        }
        .bound-table {
            text-align: center;
            font-size: 18px;
            color: #333
        }
        .other-thead {
            margin-top: 15px;
            width: 100%;
            border: 1px solid #eaeaea;
            background-color: #fafafa;
            border-bottom: transparent;
            .tip-status {
                display: inline-block;
                width: 17px;
                height: 17px;
                margin-right: 5px;
                overflow: hidden;
                background-position: 0 -191px;
                vertical-align: -3px;
                background-image: url(https://mc.meituan.net/hotel/mtp/common/bootstrap-sass/assets/images/002.png);
                background-repeat: no-repeat;
            }
        }
    }
}
</style>
<script>
import { getPhoneVerifyTable, bindPhone, unbindPhone } from "api/phoneVerify.js";
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            phones: [],
            //partnerSupplierId: 16769,
            phoneNumber: ''
        }
    },
    computed: {
        ...mapGetters(['account']),
        partnerSupplierId () {
            return  this.$route.query.supplierId || this.account.supplierId
        }
    },
    created: function() {
        getPhoneVerifyTable({
            partnerSupplierId: this.partnerSupplierId
        }).then((response) => {
            if (response.status === 0 && response.data && response.data.length) {
                this.phones = response.data;
            }
        }).catch((error) => {
            this.alert(error);
        });
    },
    methods: {
        unbindPhone: function(item) {
            unbindPhone({
                phone: item.phone
            }).then((response) => {
                if (response.status === 0) {
                    this.alert("操作成功");
                    this.getPhoneVerifyTable();
                }
            }).catch((error) => {
                this.alert(error);
            });
            
        },
        bindPhone: function() {
            bindPhone({
                phone: this.phoneNumber,
                partnerSupplierId: this.partnerSupplierId
            }).then((response) => {
                if (response.status === 0) {
                    this.alert("操作成功");
                    this.getPhoneVerifyTable();
                    this.phoneNumber = '';
                }
            }).catch((error) => {
                this.alert(error);
            });
            
        },
        getPhoneVerifyTable: function() {
            getPhoneVerifyTable({
                partnerSupplierId: this.partnerSupplierId
            }).then((response) => {
                if (response.status === 0 && response.data && response.data.length) {
                    this.phones = response.data;
                }
            }).catch((error) => {
                this.alert(error);
            });
        },
        alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// phoneVerify.vue?177ffbc5